import { CheckCircle2 } from "lucide-react";

const BackupSectionCard = ({item,Icon,toggleSection,isChecked,isBusy}) => {
  return (
    <button
      key={item.key}
      type="button"
      onClick={() => toggleSection(item.key)}
      disabled={isBusy}
      aria-pressed={isChecked}
      className={`relative rounded-2xl border p-4 pb-3.5 text-right transition-all duration-150
                        hover:-translate-y-0.5 hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-60
                        focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#B8862B]
                        ${
                          isChecked
                            ? "border-primary bg-[#9865f708] ring-1 ring-inset ring-primary"
                            : "border-[#E3DBC3] bg-white"
                        }`}
    >
      <span className="absolute top-0 left-3.5 h-2 w-5.5 rounded-b-md bg-[#F3EEE2]" />
      <div className="mb-3 flex items-center justify-between">
        <div
          className={`flex p-2 items-center justify-center rounded-[9px] transition-colors duration-150 ${
            isChecked ? "bg-primary" : "bg-[#EDE7D8]"
          }`}
        >
          <Icon
            size={18}
            className={isChecked ? "text-white" : "text-[#7A6E4E]"}
          />
        </div>
        <div
          className={`flex h-5 w-5 items-center justify-center rounded-md border-[1.5px] ${
            isChecked
              ? "border-primary bg-primary"
              : "border-[#D5CBA9] bg-white"
          }`}
        >
          {isChecked && <CheckCircle2 size={16} className="text-white" />}
        </div>
      </div>
      <div className="mb-1 text-sm font-bold">{item.label}</div>
    </button>
  );
};

export default BackupSectionCard;
